import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

import { WidgetLayout } from '../../../lib/widget-layout'
import Text from '../../../ui/Text'
import useText from '../../../common/hooks/useText'
import SearchInput from '../../../admin/components/SearchInput'

export type UsersSearchListWidgetProps = {
    clearForm: () => void
    onSubmit: React.FormEventHandler<HTMLFormElement>
    formRef: null | HTMLFormElement
    style?: React.CSSProperties
    className?: ClassName
}

export const UsersSearchListWidget = React.memo(function UsersSearchListWidget({
    style,
    className,
    formRef,
    clearForm,
    onSubmit,
}: UsersSearchListWidgetProps): React.ReactElement {
    const text = useText()
    return (
        <WidgetLayout className={cn(className)} style={style} data-testid="users-search">
            <div className="row margin-bottom-small">
                <form name="form" role="form" noValidate onSubmit={onSubmit} ref={formRef}>
                    <div>
                        <div className="col-xs-12 ">
                            <div className="form-group">
                                <SearchInput
                                    placeholder={text('lblFirstNameSmallField')}
                                    data-testid="input-firstName"
                                    id="userFirstName"
                                    key="user FirstName"
                                />

                                <SearchInput
                                    placeholder={text('lblLastNameShortField')}
                                    data-testid="input-lastName"
                                    id="userLastName"
                                    key="user LastName"
                                />
                            </div>
                        </div>

                        <div className="form-group col-xs-12 ">
                            <SearchInput
                                placeholder={text('lblEmail')}
                                data-testid="input-email"
                                id="userEmail"
                                key="user email"
                            />
                            <div className="col-xs-4 margin-top-4">
                                <label className="checkbox-form">
                                    <input
                                        id="adminStatus"
                                        key="admin status"
                                        className="checkbox-black"
                                        type="checkbox"
                                        data-testid="checkbox"
                                    />
                                    <span className="margin-bottom-5 margin-left-xsmall">
                                        <Text code="lblSupportAccess"></Text>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-4 pull-right">
                        <div className="form-actions">
                            <div className="pull-right">
                                <button className="btn btn-ok btn-sm" type="submit">
                                    <Text code="btnSearch" />
                                </button>
                                <button
                                    className="btn btn-ok btn-sm margin-2"
                                    type="button"
                                    data-testid="btn-clear"
                                    onClick={() => clearForm()}
                                >
                                    <Text code="btnClear" />
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </WidgetLayout>
    )
})
